import {Icon, Text} from '@smart/react-components';
import React, {useEffect} from 'react';
import type {Maybe} from '../../../graphql';
import FormStyles from '../../common/form-styles.module.scss';
import {useEntry} from '../../hooks/use-entry';
import {useToken} from '../../hooks/use-token';
import {useTranslations} from '../../hooks/use-translations';

interface IProps {
  translationPrefix?: string;
  successGreeting?: Maybe<string>;
  successTitle?: Maybe<string>;
}

export function Success({
  translationPrefix,
  successGreeting,
  successTitle,
}: IProps): JSX.Element {
  const translate = useTranslations();
  const {setToken} = useToken();
  const [, setEntry] = useEntry();

  useEffect(() => {
    setToken(null);
    setEntry(null);
  }, []);

  return (
    <div className={FormStyles.wrapper}>
      <Icon
        className={FormStyles.centerIcon}
        icon="successful-checkmark"
        mode={300}
      />

      <Text
        id="heading-id"
        className={FormStyles.heading}
        variant="hl-300"
        as="h1"
      >
        {translationPrefix
          ? translate(`${translationPrefix}.successPage.greeting`)
          : successGreeting}
      </Text>

      <Text
        className={FormStyles.mainText}
        variant="p-100"
        style={{fontSize: 18}}
        as="p"
      >
        {translationPrefix
          ? translate(`${translationPrefix}.successPage.title`)
          : successTitle}
      </Text>
    </div>
  );
}
